export default "__VITE_ASSET__DDBT5XOn__"